module.exports = __webpack_public_path__ + "img/streetsweeper_parked.39a94db9.svg";